"use client";

import { Button } from "@/components/ui/button";
import { useTranslations } from "next-intl";
import { Flag } from "lucide-react";

export type ReportItemType = "event" | "club";

interface ReportButtonProps {
  itemType: ReportItemType;
  itemName: string;
  itemId: string;
  relatedInfo?: string; // e.g., club name for events
}

export function ReportButton({
  itemType,
  itemName,
  itemId,
  relatedInfo,
}: ReportButtonProps) {
  const t = useTranslations();
  const subject = `Report ${itemType === "event" ? "Event" : "Club"}: ${itemName}`;
  const body =
    itemType === "event"
      ? `Event ID: ${itemId}${relatedInfo ? `\nClub: ${relatedInfo}` : ""}\n\nPlease describe the issue:`
      : `Club ID: ${itemId}\n\nPlease describe the issue:`;
  const mailtoUrl = `mailto:support@spond.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  const buttonText =
    itemType === "event"
      ? t("eventInfo.reportEvent")
      : t("clubInfo.reportClub");

  return (
    <Button
      asChild
      variant="secondary"
      className="text-sm font-medium py-2 px-4 w-full rounded-full gap-2 h-10"
    >
      <a href={mailtoUrl}>
        <Flag className="h-4 w-4" />
        {buttonText}
      </a>
    </Button>
  );
}
